<template>
  <ListItemsWithTableLayout>
    <template #body>
      <HandlerAccessDenied :is-denied="isDenied">
        <TopDashboardsPanel name-dashbords="Дашборды"></TopDashboardsPanel>
        <DashboardsViewForm
          :store="workbooksStore"
          type="own_workbook"
        ></DashboardsViewForm>
      </HandlerAccessDenied>
    </template>
  </ListItemsWithTableLayout>
</template>

<script setup lang="ts">
import { computed } from "vue";

import ListItemsWithTableLayout from "@/widgets/layouts/ListItemsWithTableLayout.vue";
import HandlerAccessDenied from "@/shared/base/HandlerAccessDenied.vue";
import TopDashboardsPanel from "@/entities/analytics/dashboards/TopDashboardsPanel.vue";
import DashboardsViewForm from "@/entities/analytics/dashboards/DashboardsViewForm.vue";

import { useAuthStore } from "@/store/auth/login";
import { useOwnWorkbooksStore } from "@/store/catalog_data/dashboards";

const authStore = useAuthStore();
const workbooksStore = useOwnWorkbooksStore();

const isDenied = computed(() => {
  return authStore.isDeniedForPermissions(
    ["system:read", "system:edit"],
    ["analytics:read", "analytics:edit"]
  );
});
</script>
